import { INSTITUTION_START, INSTITUTION_DATA, INSTITUTION_END } from '../../slices/type';

interface InitState {
  data: any[];
  dataSingle: any[];
  loading: boolean;
}

const initState: InitState = {
  data: [],
  dataSingle: [],
  loading: false,
};

interface Action {
  type: string;
  payload?: any;
  loading?: boolean;
}

const Institution_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case INSTITUTION_START:
      return { ...state, loading: action.loading ?? false };
    case INSTITUTION_DATA:
      return { ...state, data: action.payload ?? [], loading: false };
    case INSTITUTION_END:
      return { ...state, dataSingle: action.payload ?? [], loading: false };
    default:
      return state;
  }
};

export default Institution_Red;
